<div (editCancel)="closeSection();"
  mwlResizable
  [ngStyle]="style"
  [enableGhostResize]="true"
  [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
  (resizeEnd)="onResizeEnd($event)"
  class="layer half-layer px-4">
  <div class="moving">
    <layer-header 
      (closeLayer)="closeSection()" 
      [listIcons]=false 
      [title]="'Edit determinants'">
      <ng-content></ng-content>
    </layer-header>
    
    <div class="determinants-content">
      <formio-determinant-builder
        *ngIf="serviceId && componentKey"
        [direct]="true"
        [serviceId]="serviceId"
        [componentKey]="componentKey"
        [determinantMapById]="determinantMapById"
        (changeDeterminants)="changeDeterminants.emit($event)">
      </formio-determinant-builder>
    </div>

  </div>
</div>